import React from 'react';

import { PresetColorsContext } from '@neptune/compare-domain';

export function usePresetColorsContext() {
  return React.useContext(PresetColorsContext);
}
